<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">زبد البحر</h1><ol class="toc">
<li id="toc-li-2"><a href="#/text/ch002"><span dir="rtl">إسلام نمر الجمل</span></a></li><li id="toc-li-3"><a href="#/text/ch003"><span dir="rtl">الإهـداء</span></a></li><li id="toc-li-4"><a href="#/text/ch004"><span dir="rtl">حقوق النشر</span>©</a></li><li id="toc-li-5"><a href="#/text/ch005"><span dir="rtl">شكر وتقدير</span></a></li><li id="toc-li-6"><a href="#/text/ch006"><span dir="rtl">المقدِّمة</span></a></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?2afe7010